import { render } from "./VideoDetails.vue?vue&type=template&id=4d6f60d1&ts=true"
import script from "./VideoDetails.vue?vue&type=script&lang=ts"
export * from "./VideoDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__